const videoExtensions = ['mp4'];

interface UrlOptions {
  isHttps?: boolean;
  removeTrailingSlash?: boolean;
}

export default class UrlUtils {
  static getExtensionFromFileUrl(url: string) {
    return url
      .split(/#|\?/)[0]
      .split('.')
      .pop()
      .trim();
  }

  static isVideoUrl(url: string) {
    const extension = this.getExtensionFromFileUrl(url);
    return videoExtensions.includes(extension);
  }

  static FormatUrlQueryToString(query: Record<string, string>) {
    return Object.keys(query)
      .map(key => `${key}=${(query as Record<string, string>)[key]}`)
      .join('&');
  }

  static startsWithProtocol(url: string) {
    return url.startsWith('http://') || url.startsWith('https://');
  }

  static GetFullUrl(url: string, options?: UrlOptions) {
    const { isHttps = false, removeTrailingSlash = false } = options || {};

    let convertedUrl = url;
    if (removeTrailingSlash) {
      convertedUrl = url.endsWith('/') ? url.slice(0, -1) : url;
    }

    return !this.startsWithProtocol(convertedUrl)
      ? `${isHttps ? 'https://' : 'http://'}${url}`
      : url;
  }
}
